<template>
  <div class="information"
       v-if="informationList.length">
    <div class="title">
      <img class="pc-title"
           src="https://s-test.kcimg.cn/topic/images/shanqi-truck/pc/pc-title6.png"
           alt="">
      <img class="m-title"
           src="https://s-test.kcimg.cn/topic/images/shanqi-truck/m/m-title6.png"
           alt="">
    </div>
    <div class="box">
      <div class="content">
        <template v-for="(item,index) in informationList">
          <template v-if="hasShowAll||(!hasShowAll&&index<4)">
            <a :href="item.link"
               @click="enterDetail($event,item)"
               class="item"
               :key="index">
              <img :src="item.img"
                   alt="">
              <div class="info">
                <h5>{{item.title}}</h5>
                <p>{{item.desc}}</p>
                <p class="time">{{item.date}}</p>
              </div>
            </a>
          </template>
        </template>
        <div v-if="informationList.length>4&&!hasShowAll"
             class="more"
             @click="showMore">
          查看更多
        </div>
        <div v-if="informationList.length>4&&hasShowAll"
             class="pack"
             @click="hideMore">
          点击收起
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import XHR from '../api'
export default {
  name: 'RelatedInformation',
  props: [],
  data: () => ({
    informationList: [],
    hasShowAll: false
  }),
  components: {
  },
  computed: {
  },
  created () {
    XHR.getHandWork({
      type: 23,
      hid: 3844
    }).then(res => {
      const { status, data } = res.data
      if (!status) {
        this.informationList = data
      }
    }).catch(err => {
      console.log(err)
    })
  },
  mounted () { },
  methods: {
    enterDetail (ev, item) {
      ev.preventDefault()
      this.sendAnalytics('陕汽德龙X3000专题活动', '相关资讯-查看文章', item.title)
      window.location.href = item.link
    },
    showMore () {
      this.hasShowAll = true
    },
    hideMore () {
      this.hasShowAll = false
    }
  }
}
</script>
<style lang="less" scoped>
.information {
  margin-top: 78px;
  margin-bottom: 42px;
}
.title {
  .pc-title {
    display: none;
  }
  .m-title {
    margin: 0 auto;
    display: block;
    width: 300px;
  }
}
.box {
  margin: 0 auto;
  min-height: 980px;
  /*background-image: url("https://s-test.kcimg.cn/topic/images/shanqi-truck/m/m-box6.png");*/
  position: relative;
  box-sizing: border-box;
  margin-bottom: 42px;
  background-image: url(https://s-test.kcimg.cn/topic/images/shanqi-truck/m/m-box6-center.png);
  width: 690px;
  padding-top: 54px;
  padding-bottom: 34px;
  background-repeat: repeat-y;
  background-clip: content-box;
  &:before {
    content: "";
    background-image: url(https://s-test.kcimg.cn/topic/images/shanqi-truck/m/m-box6-top.png);
    background-repeat: no-repeat;
    width: 690px;
    height: 945px;
    position: absolute;
    top: 0;
  }
  &:after {
    content: "";
    background-image: url(https://s-test.kcimg.cn/topic/images/shanqi-truck/m/m-box6-bottom.png);
    background-repeat: no-repeat;
    width: 690px;
    height: 34px;
    position: absolute;
    bottom: 0;
  }
  .content {
    z-index: 1;
    width: 100%;
    padding: 0 25px;
    box-sizing: border-box;
    position: relative;
  }
  .item {
    width: 100%;
    border-bottom: 1px solid rgb(183, 1, 1);
    display: flex;
    img {
      width: 205px;
      height: 137px;
      object-fit: cover;
      border: 2px solid #f5cd94;
      margin-top: 20px;
    }
    .info {
      margin-left: 18px;
      margin-top: 16px;
    }
    h5 {
      font-size: 28px;
      color: rgb(255, 255, 255);
      font-weight: bold;
      line-height: 36px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      /*! autoprefixer: off */
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      /* autoprefixer: on */
    }
    p {
      margin-top: 12px;
      font-size: 24px;
      color: rgba(255, 255, 255, 0.5);
      line-height: 30px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      /*! autoprefixer: off */
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      /* autoprefixer: on */
      word-break: break-all;
    }
    .time {
      margin-bottom: 16px;
    }
  }
  .more,
  .pack {
    margin: 25px auto -10px;
    width: 159px;
    height: 49px;
    line-height: 49px;
    border: 1px solid rgb(245, 205, 148);
    border-radius: 5px;
    font-size: 24px;
    color: rgb(245, 205, 148);
    text-align: center;
    cursor: pointer;
  }
  .pack {
    border: none;
    position: relative;
    &:after {
      content: "";
      background: url("https://s-test.kcimg.cn/topic/images/shanqi-truck/pack-icon.png");
      position: absolute;
      width: 16px;
      height: 24px;
      right: 6px;
      top: 11px;
    }
  }
}
@media screen and (min-width: 751px) {
  .title {
    .pc-title {
      margin: 0 auto;
      display: block;
      width: 380px;
    }

    .m-title {
      display: none;
    }
  }
  .box {
    min-height: 967px;
    margin-bottom: 42px;
    background-image: url(https://s-test.kcimg.cn/topic/images/shanqi-truck/pc/pc-box6-center.png);
    width: 1000px;
    padding-top: 54px;
    padding-bottom: 35px;
    &:before {
      background-image: url(https://s-test.kcimg.cn/topic/images/shanqi-truck/pc/pc-box6-top.png);
      width: 1000px;
      height: 931px;
    }
    &:after {
      background-image: url(https://s-test.kcimg.cn/topic/images/shanqi-truck/pc/pc-box6-bottom.png);
      width: 1000px;
      height: 35px;
    }
    .item {
      img {
        width: 220px;
        height: 147px;
        margin: 30px 0;
      }
      .info {
        margin-top: 26px;
      }
      h5 {
        font-size: 32px;
        line-height: 40px;
      }
      p {
        font-size: 20px;
        line-height: 30px;
        height: 60px;
        margin-top: 13px;
      }
      .time {
        height: auto;
        margin-bottom: 0;
      }
    }
  }
}
</style>
